import { render, staticRenderFns } from "./ConnectionsHeader.vue?vue&type=template&id=4f595b08&scoped=true"
import script from "./ConnectionsHeader.vue?vue&type=script&lang=js"
export * from "./ConnectionsHeader.vue?vue&type=script&lang=js"
import style0 from "./ConnectionsHeader.vue?vue&type=style&index=0&id=4f595b08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f595b08",
  null
  
)

export default component.exports